import { Element, Tag } from "@app/types/Cue";
import { AdvertisementTypeEnum } from "@app/types/enums";
import Advertisement from "@components/Advertisement/Advertisement";
import ArticleNewsletter from "@pages/Article/components/ArticleNewsletter/ArticleNewsletter";
import { ArticleParagraphsProps } from "@pages/Article/components/ArticleParagraphs";
import ArticleSeeAlso from "@pages/Article/components/ArticleSeeAlso";
import { getFormattedTextForAds } from "@pages/Section/helpers";
import { GoogleAdsSlotFactory } from "@util/helpers";

import Paragraph from "./Paragraph";

type PropsToImport =
  | "id"
  | "seeAlso"
  | "displayRelatedLinksAndNewsletterSignupForm"
  | "keywords"
  | "index"
  | "gsChannelsNames"
  | "sections";

type ParagraphWrapperProps = Pick<ArticleParagraphsProps, PropsToImport> & {
  element: Element;
  paragraphCount: number;
  isBoxWrapped?: boolean;
  isDisplayImu1?: boolean;
};

export default function ParagraphWrapper({
  id,
  element,
  paragraphCount,
  index,
  sections,
  keywords,
  gsChannelsNames = [],
  displayRelatedLinksAndNewsletterSignupForm,
  seeAlso,
  isBoxWrapped = false,
  isDisplayImu1 = false,
}: ParagraphWrapperProps): React.ReactElement {
  const mainSection = sections?.at(0);

  return (
    <>
      <Paragraph element={element} />

      {paragraphCount === 3 && mainSection && isDisplayImu1 ? (
        <Advertisement
          adUnitProps={{
            id: index !== 0 ? `dfp-ad-imu1-${index}` : `dfp-ad-imu1`,
            type: AdvertisementTypeEnum.IMU1,
            slot: GoogleAdsSlotFactory.imu1(
              mainSection.uniqueName.replaceAll("_", "/")
            ),
            isRefresh: index !== 0,
            slotTargettings: [
              { key: "btarticleid", value: id },
              {
                key: "bttags",
                value:
                  keywords
                    ?.map((tag: Tag) => getFormattedTextForAds(tag.name))
                    .join(", ") || "",
              },
              {
                key: "gs_channels",
                value: gsChannelsNames.join(","),
              },
            ],
          }}
          rootClassName="mb-6 text-center"
        />
      ) : null}

      {!isBoxWrapped && paragraphCount === 6 ? (
        <>
          {displayRelatedLinksAndNewsletterSignupForm && seeAlso?.title ? (
            <ArticleSeeAlso
              title={seeAlso.title}
              articleId={seeAlso.articleId}
              slug={seeAlso.slug}
            />
          ) : null}

          {displayRelatedLinksAndNewsletterSignupForm &&
          sections &&
          keywords ? (
            <div className="py-10">
              <ArticleNewsletter
                rootClassName="mb-6"
                sections={sections}
                tags={keywords}
              />
            </div>
          ) : null}

          {mainSection ? (
            <Advertisement
              rootClassName="mb-6 text-center"
              adUnitProps={{
                id:
                  index !== 0
                    ? `dfp-ad-midarticlespecial-${index}`
                    : `dfp-ad-midarticlespecial`,
                type: AdvertisementTypeEnum.MIDARTICLE,
                slot: GoogleAdsSlotFactory.midarticlespecial(
                  mainSection.uniqueName.replaceAll("_", "/")
                ),
                isRefresh: index !== 0,
                slotTargettings: [
                  { key: "btarticleid", value: id },
                  {
                    key: "bttags",
                    value:
                      keywords
                        ?.map((tag: Tag) => getFormattedTextForAds(tag.name))
                        .join(", ") || "",
                  },
                  {
                    key: "gs_channels",
                    value: gsChannelsNames.join(","),
                  },
                ],
              }}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
}
